import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colorV2, cssTemplate, media, typographyV2 } from "../../../../constants/styles";
import { useIntersecting } from "../../../../hooks/useIntersecting";

interface Props {
  smallText: string;
  bigText: React.ReactNode;
}
const Text: React.FC<Props> = ({ smallText, bigText }) => {
  const { ref, isIntersecting } = useIntersecting();
  const [isInteracted, setIsInteracted] = useState<boolean>(false);

  useEffect(() => {
    if (isIntersecting) setIsInteracted(true);
  }, [isIntersecting]);

  return (
    <TextWrapper ref={ref} theme={{ isIntersecting: isInteracted }}>
      <div className="small">{smallText}</div>
      <div className="big">{bigText}</div>
    </TextWrapper>
  );
};
export default Text;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 12px;
  ${(props) => cssTemplate.fadeInOut(props)}
  & > div.small {
    text-align: center;
    ${typographyV2.BODY_2_M};
    color: ${colorV2.GRAY_10};
  }
  & > div.big {
    ${typographyV2.HEADING_1_B}
    text-align: center;
    color: ${colorV2.GRAY_10};
  }
  ${media.MOBILE} {
    & > div.small {
      ${typographyV2.BODY_4_M};
    }
    & > div.big {
      ${typographyV2.HEADING_3_B}
    }
  }
`;
